import React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import LoadingButton from "@mui/lab/LoadingButton";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import { TextField } from "formik-material-ui";
import { Grid } from "@mui/material";
import axios from "axios";
import { useTranslation } from "react-i18next";
import REACT_APP from "../../../../environment";
import regex from "tts-hrp-val-lib";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
};

function TransitionsModal({ getData }) {
    const { t } = useTranslation();
    const [loading, setLoading] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const validateCompany = Yup.object({
        goal_name: Yup.string()
            .required(t("Goal name is required"))
            .matches(regex.goal_name, { message: t("Enter valid goal name") }),
        short_description: Yup.string()
            .required(t("Short description is required"))
            .matches(regex.description, { message: t("Enter valid short description") }),
    });
    const emptyData = {
        goal_name: "",
        short_description: "",
    };

    const onSubmit = async (values) => {
        setLoading(true);
        await axios
            .post(`${REACT_APP.API}/api/hrp/v1/goal/development`, values, {
                headers: { "Content-Type": "application/json", Authorization: sessionStorage.getItem("token") },
            })
            .then((res) => {
                setLoading(false);
                toast.success("Goal added successfully");
                handleClose();
                getData();
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
                toast.error("An error occurred");
            });
    };

    return (
        <div className="addcompany">
            {loading && <div className="hrp-overlay"></div>}
            <Button onClick={handleOpen} variant="contained">
                {t("Add goal")}
            </Button>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                <Fade in={open}>
                    <Box sx={style} className="addcompanymodal">
                        <Typography id="transition-modal-title" variant="h6" component="h2" className="marginBottom">
                            {t("Enter new goal")}
                        </Typography>
                        <Formik initialValues={emptyData} validationSchema={validateCompany} onSubmit={async (values) => onSubmit(values)}>
                            {({ values, errors }) => (
                                <Form autoComplete="off" className="mt-4">
                                    <Grid container spacing={4}>
                                        <Grid item xs={12} className="marginBottom">
                                            <Field
                                                fullWidth
                                                label={t("Goal name")}
                                                name="goal_name"
                                                component={TextField}
                                                autoComplete="goal_name"
                                                type="text"
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} className="marginBottom">
                                        <Field
                                            fullWidth
                                            name="short_description"
                                            label={t("Short description")}
                                            autoComplete="short_description"
                                            component={TextField}
                                        />
                                    </Grid>
                                    <div className="right_left">
                                        <Button onClick={handleClose} variant="contained" sx={{ mt: 3, mb: 2 }} color="error" className="mt-5">
                                            {t("Close")}
                                        </Button>
                                        <>
                                            {loading ? (
                                                <LoadingButton loading variant="contained" sx={{ mt: 3, mb: 2 }} color="success" className="mt-5">
                                                    {t("Submit")}
                                                </LoadingButton>
                                            ) : (
                                                <Button type="submit" className="mt-5" variant="contained" sx={{ mt: 3, mb: 2 }} color="success">
                                                    {t("Submit")}
                                                </Button>
                                            )}
                                        </>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </Box>
                </Fade>
            </Modal>
        </div>
    );
}

export default React.memo(TransitionsModal);
